import { atom } from 'recoil';

import { CampaignGroupBy } from '@/generated';
import { ProgramAnalyticsFilterValuesType } from '@/pages/AnalyticsPage/AnalyticsPrograms/utils';
import { ProgramFieldConfigType } from '@/pages/ProgramCreatePage/utils';

export const deleteProgramAudienceConfirmationDataAtom = atom<{
  audienceId: string;
  audienceName: string;
} | null>({
  key: 'delete-program-audience-confirmation-data',
  default: null,
});

export const removeProgramSplitConfirmationDataAtom = atom<{
  audienceId: string;
  audienceName: string;
  splitName: string;
  selectedSplits: string[];
  unselectedSplits: string[];
} | null>({
  key: 'remove-program-split-confirmation-data',
  default: null,
});

export const showAudienceExclusionSectionAtom = atom<boolean>({
  key: 'show-audience-exclusion-section',
  default: false,
});

export const isProgramFieldsCollapsedAtom = atom<boolean>({
  key: 'is-program-fields-collapsed',
  default: false,
});

export const isPauseProgramModalOpenAtom = atom<boolean>({
  key: 'is-pause-program-modal-open',
  default: false,
});

export const isProgramProofsFilterDrawerOpenAtom = atom<boolean>({
  key: 'is-program-proofs-filter-drawer-open',
  default: false,
});

export const programFieldsConfigAtom = atom<ProgramFieldConfigType>({
  key: 'program-fields-config',
  default: [],
});

export const programAnalyticsIndexFilters =
  atom<ProgramAnalyticsFilterValuesType>({
    key: 'program-analytics-index-filters',
    default: {
      programIncludedTags: [],
      programExcludedTags: [],
      programFilterValue: [],
      experimentFilterValue: [],
      programStatusFilterValue: [],
    },
  });

//TODO: Replace with ProgramGroupByType when available
export const programGroupByAtom = atom<CampaignGroupBy | ''>({
  key: 'program-group-by',
  default: '',
});

export const isArchiveProgramModalOpenAtom = atom<boolean>({
  key: 'is-archive-program-modal-open',
  default: false,
});
